import Cookies from 'js-cookie'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const SERVICE_TOKEN = 'service_token'
const O365_TOKEN = 'o365_token'
const EXPIRES_ON = 'expires_on'
const REFRESH_TOKEN = 'refresh_token'
const SERVICE_TOKEN_EXPIRES = 'service_token_expires_on'
const IS_INTEGRATION = 'isIntegration'
const USER_ID = 'id'
const O365_EXPIRES_ON = 'o365_expires_on'
const USER_EMAIL = 'email'
const TOKEN_EXPIRE = 'token_expire'
const IS_USER_AD = 'isUserActiveDirectory'
const TIME_ZONE = 'timeZone'
const SERVICE = 'service'
const FIRSTNAME = 'firstName'
const LASTNAME = 'lastName'
const IS_REMEMBER = 'isRemember'
const MAX_ADVANCE_BOOKING_DAY = 'maxAdvanceBookingDay'
const MAXIMUM_BOOKING_MINUTES = 'maximumBookingMinutes'
const IS_AUTO_LOCK = 'isAutoLock'

const TARGET_URL = 'target_url'

const expiresDay = 7

function getCookie(key) {
    return Cookies.get(key)
}

function setCookie(key, value, expires) {
    if (expires) {
        Cookies.set(key, value, { expires: expires })
    } else {
        Cookies.set(key, value)
    }
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD)
}

export function getAccessToken() {
    return getCookie(SERVICE_TOKEN)
}

export function getO365Token() {
    return getCookie(O365_TOKEN)
}

export function getIsIntegration() {
    return getCookie(IS_INTEGRATION)
}

export function getServiceType() {
    return getCookie(SERVICE)
}

export function getAllToken() {
    if (!getCookie(SERVICE_TOKEN)) return {}
    return {
        access_token: getCookie(SERVICE_TOKEN),
        expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
    }
}

export function getIsRemember() {
    const isRemember = getCookie(IS_REMEMBER) === 'true' || getCookie(IS_REMEMBER) === true ? true : false
    return isRemember
}

export function getIsAutoLock() {
    const isAutoLock = getCookie(IS_AUTO_LOCK) === 'true' || getCookie(IS_AUTO_LOCK) === true ? true : false
    return isAutoLock
}

export function getToken() {
    if (!getCookie(SERVICE_TOKEN)) return {}
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION),
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    }
}

export function setToken({
    token,
    expires_on,
}) {
    setCookie(SERVICE_TOKEN, token)
    setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
}

export function getUserInfo(access_token) {
    if (!access_token) return {}

    // const {
    // //   iat,
    // //   exp,
    // //   appid,
    // //   name,
    // //   unique_name: email
    // } = jwt.decode(access_token)

    return {
        //   iat,
        //   exp,
        //   appid,
        //   name,
        //   email
    }
}

export function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN)
}

export function getUserEmail() {
    return getCookie(USER_EMAIL)
}

export function getUserId() {
    return getCookie(USER_ID)
}

export function getTimeZone() {
    return getCookie(TIME_ZONE)
}

export function getUserInformation() {
    let firstName = getCookie(FIRSTNAME),
        lastName = getCookie(LASTNAME),
        email = getCookie(USER_EMAIL),
        service = getCookie(SERVICE),
        id = getCookie(USER_ID)
    return { firstName, lastName, email, service, id }
}

export function getTokenExpire() {
    return getCookie(TOKEN_EXPIRE)
}

export function getMaximumBookingMinutes() {
    const value = getCookie(MAXIMUM_BOOKING_MINUTES)
    return parseInt(value, 10)
}

export function getMaxAdvanceBookingDay() {
    const value = getCookie(MAX_ADVANCE_BOOKING_DAY)
    return parseInt(value, 10)
}
export function setIntegration(value) {
    setCookie(IS_INTEGRATION, value)
}

export function setBSRSToken(bsrsToken) {
    const {
        isRemember,
        isIntegration,
        token,
        id,
        o365_token,
        o365_token_expire_on,
        email,
        isUserActiveDirectory,
        timeZone,
        firstName,
        lastName,
        service,
        token_expire,
        maximumBookingMinutes,
        maxAdvanceBookingDay,
        isAutoLock
    } = bsrsToken
    let expires = null,
        setIsRemember = false,
        setIsAutoLock = false
    if (typeof isAutoLock === 'boolean' && isAutoLock === true) {
        setIsAutoLock = true
    }
    if (typeof isRemember === 'boolean' && isRemember === true) {
        setIsRemember = true
        expires = expiresDay
    }

    setCookie(BSRS_ACCESS_TOKEN, token, expires)
    setCookie(IS_INTEGRATION, isIntegration, expires)
    setCookie(USER_ID, id, expires)
    setCookie(O365_TOKEN, o365_token ? o365_token : "", expires)
    setCookie(O365_EXPIRES_ON, o365_token_expire_on ? o365_token_expire_on : "", expires)
    setCookie(USER_EMAIL, email ? email : "", expires)
    setCookie(TOKEN_EXPIRE, token_expire, expires)
    setCookie(IS_USER_AD, isUserActiveDirectory, expires)
    setCookie(TIME_ZONE, timeZone, expires)
    setCookie(FIRSTNAME, firstName, expires)
    setCookie(LASTNAME, lastName, expires)
    setCookie(SERVICE, service, expires)
    setCookie(IS_REMEMBER, setIsRemember, expires)
    setCookie(MAXIMUM_BOOKING_MINUTES, maximumBookingMinutes, expires)
    setCookie(MAX_ADVANCE_BOOKING_DAY, maxAdvanceBookingDay, expires)
    setCookie(IS_AUTO_LOCK, setIsAutoLock, expires)
}
export function setMaximumBookingMinutes(maximumNumber, advanceNumber) {
    setCookie(MAXIMUM_BOOKING_MINUTES, maximumNumber)
    setCookie(MAX_ADVANCE_BOOKING_DAY, advanceNumber)
}

export function resetExpire() {
    const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
    if (isRemember === true) {
        const keys = Object.keys(Cookies.get())
        keys.forEach(key => setCookie(key, getCookie(key), expiresDay))
    }
}

export function setUserInfo({ firstName, lastName }) {
    setCookie(FIRSTNAME, firstName)
    setCookie(LASTNAME, lastName)
}

export function setRefreshToken(res) {
    if (res.value) {
        const { token, expires_on } = res.value
        const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
        let expires = null
        if (isRemember === true) {
            expires = expiresDay
        }
        if (token) {
            setCookie(BSRS_ACCESS_TOKEN, token, expires)
        }
        if (expires_on) {
            setCookie(TOKEN_EXPIRE, expires_on, expires)
        }
    }
}
export function changeIsIntrgration(value) {
    setCookie(IS_INTEGRATION, value)
}

export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(O365_TOKEN)
    removeCookie(O365_EXPIRES_ON)
    removeCookie(USER_EMAIL)
    removeCookie(TOKEN_EXPIRE)
    removeCookie(IS_USER_AD)
    removeCookie(TIME_ZONE)
    removeCookie(SERVICE)
    removeCookie(FIRSTNAME)
    removeCookie(LASTNAME)
    removeCookie(IS_REMEMBER)
    removeCookie(MAXIMUM_BOOKING_MINUTES)
    removeCookie(MAX_ADVANCE_BOOKING_DAY)
    removeCookie(IS_AUTO_LOCK)
}

export function addTargetUrl(path) {
    window.localStorage.removeItem(TARGET_URL)
    window.localStorage.setItem(TARGET_URL, path)
}

export function getTargetUrl() {
    return window.localStorage.getItem(TARGET_URL)
}

export function deleteTargetUrl() {
    window.localStorage.removeItem(TARGET_URL)
}




// WEBPACK FOOTER //
// ./src/lib/auth.js